const PADDLE_SCRIPT = "https://cdn.paddle.com/paddle/v2/paddle.js";

type PaddleClient = {
  Environment: { set: (value: "sandbox" | "production") => void };
  Initialize: (options: { token: string; pwCustomer?: { id: string } }) => void;
};

declare global {
  interface Window {
    Paddle?: PaddleClient;
  }
}

let initializedToken: string | null = null;

function loadPaddleScript(): Promise<PaddleClient> {
  if (window.Paddle) return Promise.resolve(window.Paddle);
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${PADDLE_SCRIPT}"]`);
    if (existing) {
      existing.addEventListener("load", () => {
        if (window.Paddle) resolve(window.Paddle);
        else reject(new Error("Paddle.js loaded without a client"));
      });
      return;
    }
    const script = document.createElement("script");
    script.src = PADDLE_SCRIPT;
    script.async = true;
    script.onload = () => {
      if (window.Paddle) resolve(window.Paddle);
      else reject(new Error("Paddle.js loaded without a client"));
    };
    script.onerror = () => reject(new Error("Paddle.js failed to load"));
    document.head.appendChild(script);
  });
}

export async function initializePaddle(pwCustomerId?: string | null) {
  const token = import.meta.env.VITE_PADDLE_CLIENT_TOKEN;
  if (!token || initializedToken === token) return;
  const paddle = await loadPaddleScript();
  // Live tokens default to production. Only sandbox client tokens set the sandbox env.
  if (token.startsWith("test_")) {
    paddle.Environment.set("sandbox");
  }
  paddle.Initialize({
    token,
    ...(pwCustomerId ? { pwCustomer: { id: pwCustomerId } } : {}),
  });
  initializedToken = token;
}
